import { Row, Table, Input, Typography } from 'antd'
import { LocalDateTime } from '~/components/LocalDateTime'
import { CaseDownloadButton } from '~/components/CaseDownloadButton'
import { useTableDataSourceKey } from '~/hooks/useTableDataSourceKey'
import { useCaseQuery } from '~/pages/UploadFiles/query'
import { useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { compareDate, compareNumber, compareText, formatBytes } from '~/utils/helpers'
import { useCourseQuery } from './query'
import { SearchOutlined } from '@ant-design/icons'
import { PageHeader } from '~/components/PageHeader'

const columns = (courseId) => [
  {
    title: 'ID',
    dataIndex: 'id',
    sorter: (a, b) => compareNumber(a.id, b.id)
  },
  {
    title: 'Name',
    dataIndex: 'name',
    sorter: (a, b) => compareText(a.name, b.name)
  },
  {
    title: 'Size',
    render: (cases) => formatBytes(cases.size),
    sorter: (a, b) => compareNumber(a.size, b.size)
  },
  {
    title: 'Created At',
    render: (cases) => <LocalDateTime date={cases.created_at} />,
    sorter: (a, b) => compareDate(a.created_at, b.created_at)
  },
  {
    title: 'Uploader',
    render: (cases) => cases.user?.name,
    sorter: (a, b) => compareText(a.user.name, b.user.name)
  },
  {
    title: 'Action',
    render: (cases) => (
      <CaseDownloadButton courseId={courseId} caseId={cases.id} />
    )
  }
]

const CaseDetails = () => {
  const { id } = useParams()
  const { data: uploadedCases, isLoading } = useCaseQuery(id)
  const dataSource = useTableDataSourceKey(uploadedCases)
  const [filterInput, setFilterInput] = useState('')
  const { data: course } = useCourseQuery(id)

  const totalSize = useMemo(() => {
    if (!dataSource) {
      return 0
    }

    const result = dataSource.reduce((carry, item) => {
      return carry + item.size
    }, 0)

    return formatBytes(result)
  }, [dataSource])

  const filterData = useMemo(() => {
    const filter = filterInput.toLowerCase()
    if (!dataSource) {
      return []
    }

    return dataSource.filter((cases) => cases.name.toLowerCase().includes(filter))
  }, [dataSource, filterInput])

  if (!course) {
    return null
  }

  return (
    <>
      <PageHeader
        className="radup-page-header"
        title={'Cases > ' + course?.name}
        extra={[
          <Input.Search
            key={1}
            placeholder="Search"
            allowClear
            enterButton={<SearchOutlined />}
            onSearch={setFilterInput}
          />
        ]}
        onBack={() => window.history.back()}
      />
      <Typography.Title level={5} style={{ marginTop: '16px' }}>
        Files ({totalSize})
      </Typography.Title>
      <Table
        size="small"
        tableLayout="auto"
        dataSource={filterData}
        columns={columns(id)}
        loading={isLoading}
        sticky
        pagination={false}
        scroll={{ y: 600, x: '100%' }}
        footer={() => (
          <Row justify="start">
            <span>Total: {filterData.length} cases</span>
          </Row>
        )}
      />
    </>
  )
}

export default CaseDetails
